module.exports = __webpack_public_path__ + "img/0Q3A4226_L_BlackMatted_MockedUp.305367e2.jpg";